export default __webpack_public_path__ + "static/media/switzerland.0f64b37d.webp";